import React from "react";

export default function TerrainAnalogyLegend() {
  return (
    <section className="rr-terrain-legend">
      <div>
        <span className="v25a-eyebrow">VISUAL GRAMMAR</span>
        <h4>What the terrain is allowed to mean</h4>
      </div>

      <div className="rr-terrain-legend-grid">
        <span className="affords"><i/><b>Affording route</b><small>an opening / viable relational pathway</small></span>
        <span className="constrains"><i/><b>Constraining route</b><small>friction, narrowing or pressure</small></span>
        <span className="mixed"><i/><b>Tradeoff / mixed</b><small>competing or mixed contributions</small></span>
        <span className="unresolved"><i/><b>Fog / unresolved</b><small>insufficient or unresolved topology — not negative evidence</small></span>
      </div>

      <div className="rr-terrain-limits">
        <span>greener ≠ universally good</span>
        <span>rocky ≠ moral failure</span>
        <span>fog ≠ evidence against</span>
        <span>terrain ≠ causality</span>
      </div>
    </section>
  );
}
